import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Categories from './components/Categories';

const categories = (props,{ t }) => (
  <Container>
    <Categories {...props} />
  </Container>
);

categories.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(categories);
